var _g, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownvoteSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 28,
    viewBox: "0 0 35 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.4199 18.8705L27.3636 18.8705C28.5058 18.8705 29.4242 17.9514 29.4242 16.8085L29.4242 3.25828C29.4242 2.12713 28.5058 1.19629 27.3636 1.19629L24.4199 1.19629C23.2778 1.19629 22.3594 2.12713 22.3594 3.25828L22.3594 16.8085C22.3594 17.9514 23.2778 18.8705 24.4199 18.8705Z",
    fill: "#52ACBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.70857 17.9864L10.2662 17.9864C10.2662 17.9864 9.38313 19.7539 9.38313 22.6996C9.38313 26.2344 12.0324 27.4127 13.2099 27.4127C14.3874 27.4127 14.9761 26.8235 14.9761 23.8778C14.9761 20.9321 17.6843 18.823 19.427 17.6683L19.427 3.06941C17.543 2.19748 13.7633 0.90137 7.91129 0.901369L6.02734 0.901368C3.73127 0.901368 1.77667 2.55096 1.3881 4.81326L0.0693345 12.4721C-0.425204 15.3589 1.78844 17.9864 4.70857 17.9864Z",
    fill: "#52ACBC"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 26C32.3137 26 35 23.3137 35 20C35 16.6863 32.3137 14 29 14C25.6863 14 23 16.6863 23 20C23 23.3137 25.6863 26 29 26Z",
    fill: "#FF892A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8729 19.013L28.1911 21.719L32.2883 17.5128",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownvoteSuccess);
export default __webpack_public_path__ + "static/media/downvote-success.28bf8097babf417fc42aa2e47471ead9.svg";
export { ForwardRef as ReactComponent };